import type { UserRole } from '@/types/enums';
import type { Translate } from '@/lib/i18n';

export function canManageWorkspace(role?: UserRole | null) {
  return role === 'ADMIN' || role === 'WORKSPACE_ADMIN';
}

export function userRoleLabel(role: UserRole, t: Translate) {
  switch (role) {
    case 'WORKSPACE_ADMIN':
      return t('Administrateur d’espace', 'Workspace administrator');
    case 'ADMIN':
      return t('Administrateur global', 'Global administrator');
    case 'SERVICE':
      return t('Service', 'Service');
    default:
      return t('Utilisateur', 'User');
  }
}
